import * as types from '../actionTypes/auth'

export function setAuthenticated(isAuthenticated) {
  return {
    type: types.SET_AUTHENTICATED_STATUS,
    isAuthenticated: isAuthenticated
  }
}

export function setUsername(username) {
  return {
    type: types.SET_USERNAME,
    username: username
  }
}

export function setRoles(roles) {
  return {
    type: types.SET_ROLES,
    roles: roles
  }
}

export function setCandidateId(candidateId) {
  return {
    type: types.SET_CANDIDATE_ID,
    candidateId: candidateId
  }
}

export function setCheckedForUserToken(hasCheckedForUserToken) {
  return {
    type: types.CHECKED_FOR_USER_TOKEN,
    hasCheckedForUserToken: hasCheckedForUserToken
  }
}

export function getChangePasswordDetails(changePasswordDetails) {
  return {
    type: types.GET_CHANGE_PASSWORD_DETAILS,
    changePasswordDetails: changePasswordDetails
  }
}

export function getForgotPasswordDetails(forgotPasswordDetails) {
  return {
    type: types.GET_FORGOT_PASSWORD_DETAILS,
    forgotPasswordDetails: forgotPasswordDetails
  }
}

export function clearSessionTimeOut() {
  return {
    type: types.CLEAR_SESSION_TIMED_OUT
  }
}


// WEBPACK FOOTER //
// ./src/actions/auth.js